<template>
  <div class="bespread-wrap module-layer2">
    <div class="screen-container">
      <div class="cnt">
        <img src="../../assets/img/layer2/bt.png" class="bt" />
        <div class="reg">
          <div class="lf">
            <div class="step-1">
              <img src="../../assets/img/layer2/step-1.png" class="step-1" />
              <div class="reg-cnt">
                <div class="tel-cnt mt-16 mb-8">
                  <select
                    v-model="selectAreaCode"
                    @change="handleSelectAreaCode($event)"
                    class="sel-style"
                  >
                    <option
                      v-for="(val, idx) in areaCodeList"
                      :key="idx"
                      :value="val.area"
                    >
                      {{ val.val }}
                    </option>
                  </select>
                  <input
                    type="text"
                    class="inpuy-style"
                    autocomplete="off"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    v-model="account"
                  />
                  <img
                    src="../../assets/img/layer2/code-btn.png"
                    alt=""
                    srcset=""
                    class="code-btn"
                    v-if="timeTrue"
                    @click="start_reg(1)"
                  />
                  <div v-else>
                    <div class="code-countdown-btn code-btn" v-if="time > 0">
                      <img
                        src="../../assets/img/layer2/send-btn.png"
                        alt=""
                        srcset=""
                        class="code-btn"
                        @click="start_reg(2)"
                      />
                      <div class="time-btn">({{ time }})S</div>
                    </div>
                    <img
                      src="../../assets/img/layer2/reset-code-btn.png"
                      alt=""
                      srcset=""
                      class="code-btn"
                      v-else
                      @click="start_reg(2)"
                    />
                  </div>
                </div>
                <!-- 协议 -->
                <div class="agree-txt" @click="handlePolicy">
                  <div class="c-checkbox">
                    <img
                      src="../../assets/img/layer2/c-active.png"
                      class="c-active"
                      v-if="policy"
                    />
                    <img src="../../assets/img/layer2/c.png" class="c" v-else />
                  </div>
                  <div class="txt">
                    <img
                      src="../../assets/img/layer2/agree-txt.png"
                      class="c-txt"
                    />
                    <a
                      
                       href="https://www.v-brick.com.tw/tosandprivacy2023/"
                      target="_blank"
                      class="btn-privacypolicy"
                    >
                    </a>
                    <a
                     href="https://www.v-brick.com.tw/privacy-policy2023/"
                      target="_blank"
                      class="btn-useragreement"
                    >
                    </a>
                  </div>
                </div>
                <!-- 验证码 -->
                <div class="captcha">
                  <input
                    type="text"
                    class="inpuy-style"
                    autocomplete="off"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    v-model="captchaVal"
                  />
                  <img
                    src="../../assets/img/layer2/reg-btn.png"
                    alt=""
                    srcset=""
                    class="code-btn"
                    @click="handleRegBtn()"
                  />
                </div>
              </div>
            </div>
            <div class="step-2">
              <img src="../../assets/img/layer2/step-2.png" class="step-2" />
              <div class="channel-item cursor">
                <img
                  src="../../assets/img/layer2/ios.png"
                  class="btn"
                  @click="AS_reg('ios')"
                />
                <img
                  src="../../assets/img/layer2/gg.png"
                  class="btn"
                  @click="GP_reg('gp')"
                />
              </div>
            </div>
          </div>
          <div class="lr">
            <div class="step-3">
              <img src="../../assets/img/layer2/step-3.png" class="step-3" />
              <div class="fb-icon cursor" @click="FB_reg('fb')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 错误码弹出框 -->
    <div
      class="model errModel"
      v-if="regErrModel"
      @click="handleCloseErrModel()"
    >
      <div class="bg">
        <img
          :src="require(`../../assets/img/layer2/err-${errCode}.png`)"
          alt=""
          srcset=""
          class="err-cnt"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      //香港+852
      // 澳门+853
      // 台湾+886
      // 新加坡+65
      // 马来西亚+60
      // "852", "853", "886", "065", "060"
      areaCodeList: [
        {
          area: "852",
          val: "香港+852"
        },
        {
          area: "853",
          val: "澳門+853"
        },
        {
          area: "886",
          val: "台灣+886"
        },
        // {
        //   area: "065",
        //   val: "新加坡+065"
        // },
        // {
        //   area: "060",
        //   val: "馬來西亞+060"
        // }
      ],
      selectAreaCode: "886", // 事前预约默认值
      account: "", //事前预约值
      captchaVal: "", // 验证码
      policy: false, // 协议
      timeTrue: true, // 验证码倒计时
      time: 0,
      regErrModel: false, // 错误码弹出框
      errCode: 0 //错误码
    };
  },
  methods: {
    AS_reg(val) {
      this.common.goShare(val);
    },
    GP_reg(val) {
      this.common.goShare(val);
    },
    FB_reg(val) {
      this.common.goShare(val);
    },
    // 事前预约选择区号
    handleSelectAreaCode(event) {
      this.selectAreaCode = event.target.value;
      console.log("现在选择的区号是：", event.target.value);
    },
    //验证码
    start_reg(val) {
      if (val == 1) {
        this.handleGetCode();
      } else if (val == 2) {
        this.acquire();
      }
    },
    acquire() {
      this.timeTrue = false;
      this.time = 60;
      var setTimeoutS = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(setTimeoutS);
          this.timeTrue = true;
        }
      }, 1000);
    },
    // 验证码接口
    handleGetCode() {
      if (this.account == "") {
        this.errCode = 1;
        this.regErrModel = true;
        this.$emit("changeSilderDisable");
      } else if (!this.policy) {
        this.errCode = 3;
        this.regErrModel = true;
        this.$emit("changeSilderDisable");
      } else {
        this.handleSms();
        this.regErrModel = false;
        this.$emit("changeSilderEnable");
      }
    },
    handleSms() {
      // 获取验证码接口
      const account = this.account.replace(/-/g, ""); // 只有手机预约这里才有验证码
      const reqTime = Math.floor(new Date().getTime() / 1000);
      const selectAreaCode = this.selectAreaCode;
      // 计算signature
      const params = {
        code: selectAreaCode,
        mobile: account,
        game: 166
      };

      this.$axios({
        method: "post",
        url: "sms",
        data: {
          signature: this.common.makeSignature(params, reqTime),
          reqTime: reqTime,
          code: selectAreaCode,
          mobile: account,
          game: 166
        },
        //withCredentials:true, //局部携带cookie
        headers: {} //如果需要添加请求头可在这写
      })
        .then(res => {
          if (res.data.code === 0) {
            // 验证码倒计时
            this.acquire();
          } else {
            if(res.data.code == 20001) {
              this.errCode = 7;
            }
            if (res.data.code == 20011) {
              this.errCode = 8;
            }
            if (res.data.code == 20012) {
              this.errCode = 9;
            }
            if (res.data.code == 20013) {
              this.errCode = 10;
            }
            if (res.data.code == 20014) {
              this.errCode = 6;
            }
            this.regErrModel = true;
            this.timeTrue = true;
          }
        })
        .catch(err => {});
    },
    // 勾选协议事件
    handlePolicy() {
      this.policy = !this.policy;
    },
    handleRegBtn() {
      if (this.account == "") {
        this.errCode = 1;
        this.regErrModel = true;
      } else if (!this.policy) {
        this.regErrModel = true;
        this.errCode = 3;
      } else if (this.captchaVal.toString().length !== 6) {
        this.regErrModel = true;
        this.errCode = 2;
      } else {
        this.handle_complete_reg(
          this.selectAreaCode,
          this.account.replace("-", ""),
          this.captchaVal
        );
      }
    },
    //  预注册接口联调
    handle_complete_reg(areaCode, account, captchaVal) {
      const reqTime = Math.floor(new Date().getTime() / 1000);
      let source = "unknow";
      let target = "unknow";
      let share = "unknow";
      let url = window.location.search;
      let shareParam =
        url.indexOf("share") >= 0
          ? this.common.getUrlParam("share").slice(0, -2)
          : this.common.getUrlParam("share");
      source = this.common.getUrlParam("source") || "unknow";
      target = this.common.getUrlParam("target") || "unknow";
      share = shareParam || "unknow";

      // const n_account = account.replace("-", ""); // 手机号

      // 计算signature
      const params = {
        account: account,
        game: 166,
        type: 0
      };
      this.$axios({
        method: "post",
        url: "braveheart/subscribe",
        data: {
          signature: this.common.makeSignature(params, reqTime),
          reqTime: reqTime,
          account: account,
          game: 166,
          type: 0,
          code: areaCode,
          captcha: captchaVal,
          source: source,
          target: target
          // share: share
        },
        //withCredentials:true, //局部携带cookie
        headers: {} //如果需要添加请求头可在这写
      })
        .then(res => {
          if (res.data.code === 0) {
            // this.errCode = 0;

            if (res.data.data.isNew == 1) {
              this.regErrModel = true;
              this.errCode = 4;
            } else {
              this.regErrModel = true;
              this.errCode = 5;
            }
          } else {
            this.regErrModel = true;
            this.errCode = 6;
          }
          this.time = 0;
          this.timeTrue = false;
          this.$emit("changeSilderDisable");
        })
        .catch(err => {});

      // this.regErrModel = true
      // this.$emit('changeSilderDisable')
    },
    //关闭错误弹出框
    handleCloseErrModel() {
      this.regErrModel = false;

      if (this.errCode == 4) {
        this.captchaVal = "";
        this.account = "";
        this.policy = false;
      }
      this.$emit("changeSilderEnable");
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer2 {
  background-image: url("../../assets/img/layer2/bg.png ");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  .screen-container {
    width: calc(100% - 250px);
    .cnt {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      gap: 1vw;
      .bt {
        width: 300px;
        height: auto;
      }
      .reg {
        background-image: url("../../assets/img/layer2/reg-bg.png");
        background-size: 100% 100%;
        width: 1236px;
        height: 755px;
        display: flex;
        align-items: flex-start;
        .lf {
          .reg-cnt {
            margin-left: 4.3vw;
            .code-btn {
              height: 51px;
              width: auto;
            }
            .tel-cnt {
              display: flex;
              align-items: center;
              gap: 0.3vw;
              .sel-style {
                width: 120px;
                text-align: center;
              }
              .inpuy-style {
                width: 217px;
                padding-left: 1vw;
              }

              .code-countdown-btn {
                position: relative;
              }
              .time-btn {
                position: absolute;
                right: 1vw;
                font-size: 18px;
                color: #fff;
                top: 51%;
                transform: translate(0, -50%);
                font-weight: bold;
              }
            }
            .agree-txt {
              position: relative;
              display: flex;
              align-items: center;
              margin: 0.5vw 0;
              a {
                display: block;
              }
              .c-active,
              .c {
                height: 41px;
                width: auto;
              }
              .txt {
                position: relative;
                width: 320px;
                height: 100%;

                .c-txt {
                  height: 20px;
                  width: auto;
                }
                .btn-privacypolicy {
                  width: 105px;
                  height: 20px;
                  position: absolute;
                  left: 5.5vw;
                  top: 0;
                }
                .btn-useragreement {
                  width: 100px;
                  height: 20px;
                  position: absolute;
                  right: 0;
                  top: 0;
                }
              }
            }
            .captcha {
              display: flex;
              align-items: center;
              gap: 0.3vw;
              .inpuy-style {
                width: 240px;
                padding-left: 1vw;
              }
            }
            // 输入手机号，公共样式
            input[type="text"],
            select {
              display: inline-block;
              font-size: 16px;
              font-family: KozMinStd-Bold;
              font-weight: bold;
              font-stretch: normal;
              letter-spacing: 2px;
              color: #80563d;
              background: transparent;
              height: 51px;
              line-height: 51px;
              border: 2px solid #80563d;
              background: #fff7d8;
              border-radius: 4px;
            }
          }
          .step-1 {
            width: 560px;
            height: auto;
            margin: -0.2vw 0 0.2vw -0.5vw;
          }
          .step-2 {
            width: 586px;
            height: auto;
            margin: 0vw 0 0.3vw -0.5vw;
          }
          .channel-item {
            display: flex;
            align-items: center;
            gap: 1vw;
            margin-left: 5.2vw;
            .btn {
              width: 221px;
              height: auto;
            }
          }
        }
        .lr {
          .step-3 {
            margin: -0.2vw 0 0 0.5vw;
            width: 681px;
            height: auto;
            position: relative;
          }
          .fb-icon {
            width: 100%;
            height: 8vw;
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
  }
  // 错误码弹出框
  .errModel {
    position: absolute;

    .bg {
      position: absolute;
      right: 0;
      width: calc(100% - 250px);
      height: 100%;
      .err-cnt {
        width: 613px;
        height: auto;
        position: absolute;
        left: 50%;
        top: 45%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer2 {
    .cnt {
      gap: 4vw !important;
    }
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer2 {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer2.vue